var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionAndAdventureGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Video-Game-Sword--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Video Game Sword Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.31a0.75 0.75 0 0 1 0 -1.06 0.77 0.77 0 0 1 1.07 0l8.32 8.33a0.49 0.49 0 0 0 0.36 0.15 0.47 0.47 0 0 0 0.35 -0.15l2.36 -2.36a0.5 0.5 0 0 1 0.57 -0.09 1 1 0 0 0 1.14 -0.2 1 1 0 0 0 0 -1.41 2 2 0 0 0 -2.83 0l-0.6 0.6a0.5 0.5 0 0 1 -0.37 0.14 0.48 0.48 0 0 1 -0.36 -0.17L7.43 1.1a1.51 1.51 0 0 0 -1 -0.5L1.11 0a1 1 0 0 0 -0.82 0.29 1 1 0 0 0 -0.29 0.82l0.6 5.36a1.51 1.51 0 0 0 0.5 1l11 9.83a0.49 0.49 0 0 1 0.17 0.36 0.51 0.51 0 0 1 -0.15 0.37l-0.59 0.6a2 2 0 0 0 0 2.83 1 1 0 0 0 1.41 0 1 1 0 0 0 0.2 -1.14 0.5 0.5 0 0 1 0.09 -0.57l2.36 -2.36a0.5 0.5 0 0 0 0 -0.71Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.49 21 -4.37 -4.37a0.51 0.51 0 0 0 -0.71 0l-1.77 1.77a0.51 0.51 0 0 0 0 0.71L21 23.49A1.75 1.75 0 0 0 23.49 21Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionAndAdventureGames);
export default ForwardRef;